import { Component, OnInit,Input } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { StockFilterService } from 'src/app/features/stock-screener/services/stock-filter.service';
import { ApiResponse } from 'src/app/models/sector-industries/sector-industries.model';
interface DocumentType {
  label: string;
  year: number;
  quarter: number;  // Quarter of the record (1, 2, 3, or 4)
  value: number;
}
@Component({
    selector: 'app-f-cashflow',
    templateUrl: './f-cashflow.component.html',
    styleUrls: ['./f-cashflow.component.scss'],
    standalone: false
})
export class FCashflowComponent implements OnInit {
  setLoadingState: boolean = true;
 _isAnnual: boolean = true;
   period: number[] = [2020, 2021, 2022, 2023, 2024];

   page_num:number=1
   annualData:any[]=[]
   quarterlyData:any[]=[]




   @Input() chartKey: string = '';
   constructor(private financialService: StockFilterService,
        private cd: ChangeDetectorRef) { }

   ngOnInit(): void {
      //console.log("cashflow p",this.chartKey)
    this.isAnnual = true;
    this.setLoadingState = true;
    //console.log("Ticker on Income statement is",this.chartKey)
   }



   changePeriod(periodValue: boolean): void {
      this.isAnnual = periodValue;  // This will trigger the setter
      this.setLoadingState = true;
      //console.log("Period changed:", periodValue);
    }

    get isAnnual(): boolean {
      return this._isAnnual;
    }

    set isAnnual(value: boolean) {
      this._isAnnual = value;

      // Call specific function based on value
      if (value) {
        this.getAnnualData();
      } else {
        this.getQuarterlyData();
      }
    }

    getAnnualData(){
      //this.getActualAnnualData(this.chartKey,"annual",this.period,this.page_num,this.annualData)
      this.getNewActualAnnualData(this.chartKey,"annual",this.page_num,this.annualData)
     }
     getQuarterlyData(){
      //console.log("Fetching quarterly data...");
      this.getNewActualQuarterlyData(this.chartKey,"quarterly",this.page_num,this.quarterlyData)

     }

     async getActualAnnualData(ticker: string, freq: string, period: number[], page_num: number, targetArray: any[]) {
       try {
         const topLabels = [
            'Net income',
            'Cash paid for interest',
            'Deferred revenue',
            'Depreciation and amortization',
            'Share-Based Compensation Expense',
            'Other',
            'Accounts receivable, net',
            'Vendor non-trade receivables',
            'Inventories',
            'Other current and non-current liabilities',
            'Cash generated by operating activities',
            'Investing Activities',
            'Purchases of marketable securities',
            'Proceeds from maturities of marketable',
            'Proceeds from sales of marketable',
            'Payments for acquisition of',
            'Cash Generated by',
            'Financial Activities',
            'Payments for taxes related to net share settlement of equity awards',
            'Payments for dividends and dividend equivalents',
            'Repurchases of common stock',
            'Proceeds from issuance of term debts, net',
            'Proceeds from commercial paper, net - Proceeds from/(Repayments of) commercial paper, net',
            'Cash Generated by Investing Activities - Net cash generated by investing activities',
        ];
           let allData: any[] = [];  // Array to store all documents across pages
           let hasMoreData = true;

           // Continue fetching data as long as there is data in the response
           while (hasMoreData) {
               // Call the financialService method to fetch chart data (assuming it returns a Promise<ApiResponse>)
               const response = await this.financialService.getAnnualIncomeStatement(ticker, freq, period, "cf", page_num,"asc");

               if (response && response.hits && response.hits.length > 0) {
                  //console.log("Response hits:", response.hits); // Log hits array

                   // Collect the documents into the allData array
                   allData.push(...response.hits);

                   // Check if we should continue fetching more data
                   if (response.hits.length < 100) {
                       hasMoreData = false; // No more data to fetch (or if hits are less than a page size)
                   } else {
                       page_num++; // Increment the page number for the next request
                   }
               } else {
                   //console.error("No data found in the response.");
                   hasMoreData = false; // Stop the loop if no data is returned
               }
           }

           // After collecting all data, we process it
           //console.log("All Data Collected:", allData); // Log all data collected so far

           // Define an interface for the document structure
           interface DocumentType {
               label: string;
               year: number;
               value: number;
           }

           // Initialize a Map to store labels and their values
           const labelMap = new Map<string, Record<number, number>>();

           // Function to process each document
           const processDocument = (hit: { document: DocumentType }) => {
               const doc = hit.document; // Extract document
               //console.log("Processing document:", doc); // Log each document

               const { label, year, value } = doc; // Destructure from document
               //console.log("Label:", label, "Year:", year, "Value:", value); // Log individual fields

               if (!labelMap.has(label)) {
                   //console.log(`Adding new label: ${label}`); // Log when adding new label
                   // If the label doesn't exist, create a new entry
                   labelMap.set(label, { [year]: value });
               } else {
                   //console.log(`Updating label: ${label}`); // Log when updating an existing label
                   // If the label exists, update the year's value
                   const labelData = labelMap.get(label)!;
                   labelData[year] = value; // Add the year and value
                   labelMap.set(label, labelData);
               }
           };

           // Process each document in the collected data
           allData.forEach(processDocument);

           // Log the final label map to verify if it's populated
           //console.log("Label map after processing:", labelMap);

           // Convert the Map to the desired structure (Array of label values)
           const result = Array.from(labelMap.entries()).map(([label, data]) => ({
               label,
               data
           }));

            // ✅ Filter out empty `data` objects before returning
        const filteredResult = result.filter(item => item.data && Object.keys(item.data).length > 0);

        // Log the filtered result
        //console.log("Filtered Result:", filteredResult);

        // Append the filtered result to the targetArray
        targetArray.push(...filteredResult);
        this.setLoadingState=false

        return filteredResult;

       } catch (error) {
        this.setLoadingState=false
           //console.error('Error fetching data:', error);
           throw error; // Re-throw the error for further handling
       }
   }

   async getNewActualAnnualData(
    ticker: string,
    freq: string,
    page_num: number,
    targetArray: any[]
  ) {
    try {
      // Define the priority labels in the desired order
      const topLabels = [
  'netIncomeStartingLine',            // Net Income
  'netOperatingCashFlow',             // Net Cash from Operating Activities
  'stockBasedCompensation',           // Stock-Based Compensation Expense
  'depreciationAmortization',         // Depreciation & Amortization
  'otherFundsNonCashItems',           // Other Non-Cash Items
  'changesinWorkingCapital',          // Change in Working Capital
  'netInvestingCashFlow',             // Net Cash from Investing Activities
  'capex',                            // "Capital Expenditure" – no matching key
  'otherInvestingCashFlowItemsTotal', // Other Investing Cash Flow Items
  'netCashFinancingActivities',       // Net Cash from Financing Activities
  'issuanceReductionDebtNet',         // Net Issuance (Reduction) of Debt
  'otherFundsFinancingItems',         // Other Financing Cash Flow Items
  'cashDividendsPaid',                // Payments for Dividends and Dividend Equivalents
  'cashTaxesPaid'                     // Payments for Taxes
      ];

      let allData: any[] = [];
      let hasMoreData = true;

      // Fetch data until there are no more pages (assuming less than 100 hits means last page)
      while (hasMoreData) {
        const response = await this.financialService.getNewIncomeData(ticker, freq, page_num);
      //   console.log("Response is", response);

        if (response && response.hits && response.hits.length > 0) {
          allData.push(...response.hits);
          if (response.hits.length < 100) {
            hasMoreData = false;
          } else {
            page_num++;
          }
        } else {
          hasMoreData = false;
        }
      }

      // Build a map where the key is the label (only for topLabels) and the value is an object mapping year to value.
      const labelMap = new Map<string, Record<string, number>>();

      // Process each document/hit
      allData.forEach((hit: any) => {
        const doc = hit.document;
        const year = doc.year;
        if (!year) return; // Skip if no year is provided

        // Only process the labels specified in topLabels
        topLabels.forEach(label => {
          if (doc[label] !== undefined && doc[label] !== "" && doc[label] !== null) {
            const value = parseFloat(doc[label]);
            if (!isNaN(value)) {
              if (!labelMap.has(label)) {
                labelMap.set(label, { [year]: value });
              } else {
                const existingData = labelMap.get(label)!;
                existingData[year] = value;
                labelMap.set(label, existingData);
              }
            }
          }
        });
      });

      // Convert the Map into an array, preserving the order defined in topLabels
      const result = Array.from(labelMap.entries())
        .map(([label, data]) => ({ label, data }))
        .sort((a, b) => topLabels.indexOf(a.label) - topLabels.indexOf(b.label));

      // Filter out any entries that have no data (just in case)
      const filteredResult = result.filter(item => item.data && Object.keys(item.data).length > 0);

      this.setLoadingState = false;
      targetArray.push(...filteredResult);
      // console.log("target array is ", targetArray);

      return filteredResult;
    } catch (error) {
      this.setLoadingState = false;
      throw error;
    }
  }



  async getNewActualQuarterlyData(
   ticker: string,
   freq: string,
   page_num: number,
   targetArray: any[]
) {
   try {
      let allData: any[] = [];
      let hasMoreData = true;

      while (hasMoreData) {
         const response = await this.financialService.getNewIncomeData(
            ticker,
            freq,
            page_num
         );
         // console.log('Response 2 is', response);

         if (response?.hits?.length > 0) {
            allData.push(...response.hits);
            hasMoreData = response.hits.length >= 100;
            if (hasMoreData) page_num++;
         } else {
            hasMoreData = false;
         }
      }

      const labelMap = new Map<string, Record<string, number>>();
      const topLabels = [
         'netIncomeStartingLine',            // Net Income
         'netOperatingCashFlow',             // Net Cash from Operating Activities
         'stockBasedCompensation',           // Stock-Based Compensation Expense
         'depreciationAmortization',         // Depreciation & Amortization
         'otherFundsNonCashItems',           // Other Non-Cash Items
         'changesinWorkingCapital',          // Change in Working Capital
         'netInvestingCashFlow',             // Net Cash from Investing Activities
         'capex',                            // "Capital Expenditure" – no matching key
         'otherInvestingCashFlowItemsTotal', // Other Investing Cash Flow Items
         'netCashFinancingActivities',       // Net Cash from Financing Activities
         'issuanceReductionDebtNet',         // Net Issuance (Reduction) of Debt
         'otherFundsFinancingItems',         // Other Financing Cash Flow Items
         'cashDividendsPaid',                // Payments for Dividends and Dividend Equivalents
         'cashTaxesPaid'                     // Payments for Taxes
             ];

      allData.forEach((hit: any) => {
         const doc = hit.document;
         if (!doc?.period) return; // Skip if period is missing
         if (/^\d{4}$/.test(String(doc.period))) return; // Skip annual records

         const quarterLabel = this.formatQuarterLabel(doc.period);
         if (!quarterLabel) return;

         topLabels.forEach((label) => {
            const value = parseFloat(doc[label]);
            if (!isNaN(value)) {
               if (!labelMap.has(label)) {
                  labelMap.set(label, { [quarterLabel]: value });
               } else {
                  labelMap.get(label)![quarterLabel] = value;
               }
            }
         });
      });

      const result = Array.from(labelMap.entries()).map(([label, data]) => ({
         label,
         data,
      }));

      this.setLoadingState = false;

      // Directly updating the reference instead of modifying the array
      this.quarterlyData = [...result];
      // console.log('Updated quarterlyData:', this.quarterlyData);

      // Manually trigger change detection
      this.cd.detectChanges();
   } catch (error) {
      this.setLoadingState = false;
      console.error('Error fetching quarterly data:', error);
   }
}

formatQuarterLabel(dateString: string): string | null {
   if (!dateString) return null;

   const date = new Date(dateString);
   if (isNaN(date.getTime())) {
      console.error('Invalid date:', dateString);
      return null;
   }

   const month = date.getMonth() + 1;
   const year = date.getFullYear().toString().slice(-2);
   const quarter = Math.ceil(month / 3);

   return `Q${quarter}'${year}`;
}







   formatValue = (value: number | string | undefined): string => {
      if (value === undefined || value === null || value === '') {
        return '-';
      }

      // Convert string values to numbers
      const numericValue = typeof value === 'string' ? parseFloat(value) : value;

      // Handle NaN cases (e.g., invalid strings)
      if (isNaN(numericValue)) {
        return '-';
      }

      const absValue = Math.abs(numericValue);

      // Handle billions
      if (absValue >= 1_000_000_000) {
        return (numericValue / 1_000_000_000).toFixed(2) + ' B';
      }

      // Handle millions
      if (absValue >= 1_000_000) {
        return (numericValue / 1_000_000).toFixed(2) + ' M';
      }

      // Handle decimal numbers - round to 2 decimal places and remove trailing zeros
      if (Number.isFinite(numericValue)) {
        return numericValue.toFixed(2).replace(/\.?0+$/, '');
      }

      return numericValue.toString();
    };

}
